import { NavController } from '@ionic/angular'
import { Component, OnDestroy } from '@angular/core'
import { EventService, IEvent } from './../../services/event/event.service'
import { ExtraService } from './../../services/extra/extra.service'
import { AlertService } from './../../services/alert/alert.service'
import { UserService, IUser } from './../../services/user/user.service'
import { LoadingController } from '@ionic/angular'

@Component({
  selector: 'app-my-plan',
  templateUrl: './my-plan.page.html',
  styleUrls: ['./my-plan.page.scss'],
})
export class MyPlanPage implements OnDestroy {

  user: IUser = null
  userSubscription: any

  eventList: IEvent[] = []
  eventListSubscription: any

  myPayList: { price: string, id: number, name: string, timestamp: Date, payTo: string, cancelled: boolean }[] = []
  myPayList_returnee: { price: string, id: number, name: string, payTo: string[] }[] = []
  toMePayList: { price: string, id: number, name: string, timestamp: Date, payers: string[], cancelled: boolean }[] = []
  toMePayList_returnee: { price: string, id: number, name: string, payer: string }[] = []

  constructor(
    private extraService: ExtraService,
    private eventService: EventService,
    private userService: UserService,
    private alert: AlertService,
    private navCtrl: NavController,
    private loadingController: LoadingController
  ) {
    this.userSubscription = this.userService.currentUser.subscribe(value => this.user = value)
    this.eventListSubscription = this.eventService.eventList.subscribe(value => {
      // console.log(value)
      this.eventList = value
        .filter(v => {
          /* if (
            (!this._toBoolean(v.cancelled) && (typeof v.takesPart !== 'undefined' && v.takesPart !== null && v.takesPart !== 0)) ||
            (this._toBoolean(v.cancelled) && v.hasTicketsFrom && this._toBoolean(v.paid) && v.hasTicketsFrom !== this.user.name) ||
            (this._toBoolean(v.cancelled) && v.buysTicketsFor && v.users.findIndex(u => u.hasTicket === this.user.id && u.userId !== this.user.id && this._toBoolean(u.paid)) !== -1)
          ) */

          if (!this._toBoolean(v.cancelled))
            return (typeof v.takesPart !== 'undefined' && v.takesPart !== null && v.takesPart !== 0) ||
              (v.hasTicketsFrom && !this._toBoolean(v.paid) && v.hasTicketsFrom !== this.user.name) ||
              (v.buysTicketsFor && v.users.findIndex(u => u.hasTicket === this.user.id && !this._toBoolean(u.paid) && u.userId !== this.user.id) !== -1)

          else
            return (v.hasTicketsFrom && this._toBoolean(v.paid) && v.hasTicketsFrom !== this.user.name) ||
              (v.buysTicketsFor && v.users.findIndex(u => u.hasTicket === this.user.id && this._toBoolean(u.paid) && u.userId !== this.user.id) !== -1)

          // return null
        })

      // console.log(this.eventList)

      this.myPayList = value
        .filter(e => e.hasTicketsFrom && !e.paid && e.hasTicketsFrom !== this.user.name && !this._toBoolean(e.cancelled))
        .map(e => ({ price: e.price, id: e.id, name: e.name, timestamp: e.timestamp, payTo: e.hasTicketsFrom, cancelled: e.cancelled }))

      this.myPayList_returnee = value
        .filter(e => e.buysTicketsFor && this._toBoolean(e.cancelled))
        .map(e => ({
          price: e.price, id: e.id, name: e.name,
          payTo: e.buysTicketsFor.filter(f => f !== this.user.name && e.users.findIndex(u => u.name === f && u.paid) !== -1)
        }))
        .filter(e => e.payTo.length !== 0)

      this.toMePayList = value
        .filter(e => e.buysTicketsFor && !this._toBoolean(e.cancelled))
        .map(e => ({
          price: e.price, id: e.id, name: e.name, timestamp: e.timestamp, cancelled: e.cancelled,
          payers: e.buysTicketsFor.filter(f => f !== this.user.name && e.users.findIndex(u => u.name === f && !u.paid) !== -1)
        }))
        .filter(e => e.payers.length !== 0)

      this.toMePayList_returnee = value
        .filter(e => e.hasTicketsFrom && e.hasTicketsFrom !== this.user.name && this._toBoolean(e.cancelled) && e.paid)
        .map(e => ({ price: e.price, name: e.name, id: e.id, payer: e.hasTicketsFrom }))

      // console.log(value)
    })
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe()
    this.eventListSubscription.unsubscribe()
  }

  update() {
    this.loadingController.create({
      message: 'Wird geladen',
      showBackdrop: false
    })
      .then(loading => loading.present()
        .then(() => this.extraService.updateAllLists(this.user.token, this.user.id))
        .catch((err) => this.alert.errorHandler(err, 'Fehler beim Aktualizieren von Daten!'))
        .then(() => loading.dismiss())
      )
  }

  trackByFn(index, item) {
    return item.id
  }

  gotoEventDetails(eventId: number) {
    this.navCtrl.navigateForward(`/event-details/${eventId}`)
  }

  gotoProfile() {
    this.navCtrl.navigateForward('/profile')
  }

  buysTicketsForHelperFunc(nameList: string[]) {
    return nameList.map(m => m === this.user.name ? 'mich' : m)
  }

  _toBoolean(val) {
    if (typeof val !== 'undefined' && (val === true || val === 'true' || val === '1' || val === 1))
      return true
    else
      return false
  }

  formatPrice(price: string) {
    if (price.indexOf('€') === -1)
      return '€ ' + price
    else
      return price
  }
}
